import { serializeMessages, sortMessages } from './message';
import { TYPES } from '../../consts/chains';

export const serializeChainType = service => {
  switch (service) {
    case 'insta_i2crm':
    case 'insta_local':
    case 'insta_official':
      return TYPES.INSTAGRAM;
    case 'tg_user':
      return TYPES.TELEGRAM;
    case 'wa_cm':
    case 'wa_infobip':
    case 'wa_clickatell':
    case 'wa_dialog':
    case 'wa_tr':
    case 'wa_wavy':
    case 'wa_botmaker':
      return TYPES.WHATSAPP;
    case 'viber_public':
    case 'viber_business':
    case 'viber_infobip':
    case 'viber_tr':
      return TYPES.VIBER;
    case 'yandex_dialogs':
      return TYPES.YANDEX;
    case 'email':
      return TYPES.MAIL;
    case 'max_bot':
      return TYPES.MAX;
    default:
      return service;
  }
};

export const serializeChain = chainRaw => ({
  id: chainRaw.chain.id.toString(),
  messages:
    chainRaw.messages &&
    sortMessages(
      serializeMessages(
        chainRaw.messages,
        chainRaw.persons,
        chainRaw.attachments
      )
    ),
  subject: chainRaw.chain.subject,
  type: serializeChainType(chainRaw.chain.kind),
  chatId: chainRaw.contact ? chainRaw.contact.chat_id : null,
  service: chainRaw.chain.kind,
  unreadMessages: chainRaw.chain.unread_messages,
  messenger: chainRaw.chain.messenger,
  success: chainRaw.success,
  page: chainRaw.meta && chainRaw.meta.page,
  size: chainRaw.meta && chainRaw.meta.size,
  total: chainRaw.meta && chainRaw.meta.total,
  totalPages: chainRaw.meta && chainRaw.meta.total_pages,
  autoScroll: false,
  shouldScrollToBottom: false,
  lastReceiveMessage: '',
  unreadMessagesCount: chainRaw.unread_messages_count,
  from: chainRaw.chain.from,
  subAgentClientId: chainRaw.chain.sub_agent_client_id,
  acceptedSuggestionId: null,
  declinedSuggestionIds: [],
  subAgentName: chainRaw.chain.sub_agent_name,
  subjects: chainRaw.chain.to,
  subjectsCopy:
    (chainRaw.chain.cc &&
      typeof chainRaw.chain.cc === 'string' &&
      chainRaw.chain.cc.split(',')) ||
    [],
  subjectsHideCopy:
    (chainRaw.chain.bcc &&
      typeof chainRaw.chain.bcc === 'string' &&
      chainRaw.chain.bcc.split(',')) ||
    [],
});

export const serializeSquashedChain = chain => ({
  id: chain.id && chain.id.toString(),
  title: chain.subject,
  ticketId: chain.ticket_id && chain.ticket_id.toString(),
  rootTicketId: chain.root_ticket_id,
  rootChainId: chain.root_chain_id,
  type: serializeChainType(chain.kind),
  service: chain.kind,
  to: chain.to,
  unreadAmount: chain.unread_messages_count,
  time: chain.last_answered_at || chain.updated_at,
});

export const serializeCopilotSuggest = suggest => ({
  id: suggest.id,
  text: suggest.text,
});

export const serializeChains = chains =>
  chains.map(chain => serializeSquashedChain(chain));

export const serializeCopilotSuggestions = suggestions => {
  if (!suggestions || !suggestions.length) return [];

  return suggestions.map(serializeCopilotSuggest);
};
